import { AnnoSourceType } from '@/types';

import { annoTrackIdGenerator } from './GenerateTrackId';

export type AnnoCompoundItemOptions = {
  trackId?: string;
  source?: AnnoSourceType;
  attrs?: Record<string, string[]>;
  indicateLine?: string;
};

/**
 * 组合标注物，在画布中是没有实体的，组合标注物 source 都是 manual，没有连续帧的逻辑
 */
export class AnnoCompoundItem {
  public name: string; // 标注物的唯一标识，就是 anno_v1_Object 的 uuid
  public trackId: string; // 标注物的显示id，形式为递增的整数字符串；一个任务包中，相同的 track_id 表示同一个实体对象
  public label: string; // 所属标签
  public attrs: Record<string, string[]>; // 标注属性数据
  public compound: string[]; // 标注物的子标注物的 name 列表

  public source: AnnoSourceType;

  public indicateLine?: string; // 引导线

  constructor(name: string, label: string, compound: string[], options?: AnnoCompoundItemOptions) {
    const { trackId, attrs = {}, source = 'manual', indicateLine = '' } = options || {};
    this.name = name;
    this.label = label;
    this.attrs = attrs;
    this.trackId = trackId ?? annoTrackIdGenerator.createTrackId();
    this.compound = compound;
    this.source = source;
    this.indicateLine = indicateLine;
  }

  static createFromObject(obj: Pick<AnnoCompoundItem, keyof AnnoCompoundItem>) {
    return new AnnoCompoundItem(obj.name, obj.label, obj.compound, obj);
  }

  static isAnnoCompoundObject(data: Record<string, any>): data is Pick<AnnoCompoundItem, keyof AnnoCompoundItem> {
    if (typeof data.name === 'string' && Array.isArray(data.compound) && data.compound.length > 0) {
      return true;
    }
    return false;
  }

  public updateLabelAndAttrs(label?: string, attrs?: Record<string, string[]>) {
    if (label) {
      this.label = label;
    }
    if (attrs) {
      this.attrs = attrs;
    }
  }
}
